import styled from 'styled-components';
import { LinearProgress } from '@mui/material';
import { theme } from '../../styles/theme';
export const Wrapper = styled(LinearProgress) `
  && {
    background: ${theme.colors.backgroundBrandLight};

    .MuiLinearProgress-bar {
      background: ${theme.colors.backgroundBrand};
    }
  }
`;
